<script lang="ts">
    import LastmileFilter from '../LastmileFilter.svelte';
    import { filter } from '../../../stores/filter';
    import { jobs_filter_config } from '../../../stores/api';
    import type { WidgetManager } from './WidgetManager';
    import { FilterManagerIO } from '../../components/telematics/components/FilterByParameters/FilterManagerIO';
    import type { localStorageFilterType } from '../../components/telematics/components/FilterByParameters/FilterManager';
    import { afterUpdate, onMount } from 'svelte';
    import { type QueriesType, QueriesTypeSchema } from '../../components/telematics/types';

    export let filteredCount: number = 0;
    export let totalCount: number = 0;
    export let makeBlured: boolean = false;
    export let widgetManager: WidgetManager;
    export let onChangeFilters: (queries: any) => void;
    // export let setFilters: (queries: any) => void;

    // let filterManagerStorageKey: string = widgetManager.getApi().getDashboardKey();

    // function updateFilters(managerStorageKey: string, queries: any) {
    //     filter.dashboard = {
    //         managerStorageKey: managerStorageKey,
    //         queries: queries,
    //     };
    // }

    let filterManagerIO: FilterManagerIO | null = null;

    function setFilterManagerIO(queries: QueriesType) {
        filterManagerIO = new FilterManagerIO(
            async () => {
                let data: localStorageFilterType = {
                    mainFilterData: {
                        queries: queries,
                        related: [],
                    },
                    lastUsedFilterData: {
                        queries: queries,
                        related: [],
                    },
                    __inactiveQueriesKeys: [],
                    __andOrSelection: 'and',
                };
                console.log('WidgetApi, filterManagerIO, load', data);
                return data;
            },
            async data => {
                console.log('WidgetApi, filterManagerIO, save', data);
                widgetManager.mainQuery = data.mainFilterData.queries;
                await widgetManager.save();
            }
        );
    }

    let filterComponent: any;

    setFilterManagerIO(widgetManager.mainQuery);

    afterUpdate(() => {
        filterComponent.updateFilters(widgetManager.mainQuery, false);
    });

    $: {
        console.log('WidgetApi, FilterManagerIO, init1', widgetManager.mainQuery);
        widgetManager.mainQuery = QueriesTypeSchema.catch({}).parse(widgetManager.mainQuery);
        console.log('WidgetApi, FilterManagerIO, init2', widgetManager.mainQuery);
        setFilterManagerIO(widgetManager.mainQuery);
        // if (filterComponent) {
        //     filterComponent.updateFilters(widgetManager.mainQuery, false);
        // }
    }
</script>

{#if filterManagerIO}
    <LastmileFilter
        bind:this={filterComponent}
        collectionName="jobs"
        onChange={queries => {
            console.log('WidgetApi, DashboardFilter, onChange, filter', queries);
            $filter.dashboard.queries = queries;
            widgetManager.mainQuery = queries;
            // widgetManager.save();
            widgetManager.reloadAllWidgets();
            onChangeFilters(queries);
        }}
        showQuickFilters={false}
        filterConfig={$jobs_filter_config}
        enableInactiveQueries={false}
        filterManagerStorageKey={null}
        {filterManagerIO}
        {filteredCount}
        {totalCount}
        {makeBlured}
        visibleFilterIcon={false}
    />
{/if}
